import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function Journey() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -280,
        behavior: 'smooth'
      });
    }
  };
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 280,
        behavior: 'smooth'
      });
    }
  };
  const steps = [{
    title: 'Стартова діагностика маркетингу Вашого бізнесу',
    description: 'Онлайн-опитування',
    artifact: 'Діагностична карта бізнесу'
  }, {
    title: 'Сформуємо портрет Вашого бізнесу на основі даних і контексту',
    description: '',
    artifact: 'Портрет бізнесу'
  }, {
    title: 'Впровадимо внутрішню аналітику Armar Solutions (Data → Insights)',
    description: 'Навчитесь читати ключові цифри всередині свого бізнесу та маркетингу.',
    artifact: 'Dashboard з основними маркетинговими метриками'
  }, {
    title: 'Юніт-економіка маркетингу',
    description: 'Фінансова логіка рішень до запуску маркетингу.',
    artifact: 'Формула юніт-економіки, Приклади'
  }, {
    title: 'Шаблони та інструменти управління',
    description: '',
    artifact: 'Набір маркетингових шаблонів (таблиці, регламенти, майнд-карти, гайди)'
  }, {
    title: 'Групові сесії з ментором та маркетинг-коучами',
    description: 'Робота з логікою рішень і коректним впровадженням процесів.',
    artifact: 'до 2 годин роботи на тиждень'
  }, {
    title: 'Власна Growth Acquisition System',
    description: 'Побудова системи залучення клієнтів під ваш бізнес. 8 макрорівнів та Десятки мікроелементів, що впливають на залучення.',
    artifact: 'Acquisition System — Розуміння залучення клієнтів на макро- і мікрорівні'
  }, {
    title: 'Середовище лідерів і нетворкінг',
    description: 'Робочий чат + супровід ментора. Випускний – жива зустріч',
    artifact: ''
  }, {
    title: 'Прокачаємо не лише інструменти, а мислення лідера',
    description: 'Ментальні моделі підприємницьких рішень.',
    artifact: 'Чек-лист ментальних моделей'
  }, {
    title: 'Реалізація та партнерство',
    description: 'Підключаємо перевірені команди підрядників або допомагаємо зібрати команду.',
    artifact: 'Сильна маркетинг-команда'
  }];
  return <section className="pt-0 pb-12 md:pb-24 relative overflow-hidden -mt-4" data-id="element-299">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 relative z-10" data-id="element-300">
        <div className="text-center mb-6 md:mb-12" data-id="element-301">
          <h2 className="text-lg sm:text-xl md:text-4xl font-bold mb-2 md:mb-4 max-w-4xl mx-auto px-2" data-id="element-302">
            Як ми проведемо Вас до особистого{' '}
            <span className="text-blue-400" data-id="element-303">апґрейду</span> в бізнесі та
            маркетингу
          </h2>
          <p className="text-sm md:text-xl text-gray-400" data-id="element-304">
            Система →{' '}
            <span className="text-blue-400 font-semibold" data-id="element-305">10 кроків</span>
          </p>
        </div>

        {/* Navigation */}
        <div className="flex justify-end gap-2 mb-3 md:mb-6" data-id="element-306">
          <button onClick={scrollLeft} className="p-2 md:p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors" data-id="element-307">
            <ChevronLeft className="w-4 h-4 md:w-5 md:h-5" data-id="element-308" />
          </button>
          <button onClick={scrollRight} className="p-2 md:p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors" data-id="element-309">
            <ChevronRight className="w-4 h-4 md:w-5 md:h-5" data-id="element-310" />
          </button>
        </div>

        {/* Slider */}
        <div ref={scrollRef} className="flex gap-3 md:gap-6 overflow-x-auto pb-4 md:pb-6 scrollbar-hide snap-x snap-mandatory" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-311">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex-shrink-0 w-[260px] sm:w-[280px] md:w-[320px] snap-start" data-id="element-312">
              <div className="h-full bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-4 md:p-6 relative overflow-hidden min-h-[220px] md:min-h-[280px]" data-id="element-313">
                {/* Company Logo Visual - Blue ribbon in bottom-left corner at 45 degrees, shifted more left */}
                <div className="absolute -bottom-2 -left-4 w-28 h-28 overflow-hidden pointer-events-none" data-id="element-314">
                  <div className="absolute w-36 h-9 bg-gradient-to-r from-blue-600 to-blue-400 flex items-center justify-center shadow-lg" style={{
                transform: 'rotate(45deg)',
                transformOrigin: 'center center',
                bottom: '12px',
                left: '-32px',
                position: 'absolute'
              }} data-id="element-315">
                    <img src="https://cdn.magicpatterns.com/uploads/nLYAQxxf2fUsZMfCEPYnRh/Group_9.svg" alt="ARMAR" className="h-3.5 w-auto opacity-95" data-id="element-316" />
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-sm md:text-lg font-bold text-white mb-2 md:mb-3 leading-tight pr-2" data-id="element-317">
                  {step.title}
                </h3>

                {/* Description */}
                {step.description && <p className="text-xs md:text-sm text-gray-400 mb-2 md:mb-4 leading-relaxed" data-id="element-318">
                    {step.description}
                  </p>}

                {/* Artifact */}
                {step.artifact && <div className="pt-2 md:pt-4 border-t border-white/10 mb-10 md:mb-12" data-id="element-319">
                    <p className="text-xs text-blue-400 font-medium" data-id="element-320">
                      Артефакт:{' '}
                      <span className="text-gray-300" data-id="element-321">{step.artifact}</span>
                    </p>
                  </div>}
              </div>
            </motion.div>)}
        </div>

        {/* Bottom Text */}
        <div className="mt-6 md:mt-12 text-center" data-id="element-322">
          <h3 className="text-lg md:text-2xl font-bold text-white mb-2" data-id="element-323">
            Наостанок
          </h3>
          <p className="text-xs md:text-base text-gray-400 px-4" data-id="element-324">
            Можливість партнерства для найсильніших учасників програми.
          </p>
        </div>
      </div>
    </section>;
}